<template>
  <rest-list-action
    icon="el-icon-document-copy"
    :title="$t(title ? title : 'RestList_Action_Copy')"
    :route="route"
    data-qa="copy-action-button"
  />
</template>

<script>
import RestListAction from '@/common/components/rest/RestListAction'

export default {
  name: 'RestListActionCopy',

  components: { RestListAction },

  props: {
    route: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionCopy.vue